interface CacheEntry<T> {
  promise: Promise<T> | null
  value: T | null
  timestamp: number
}

const cache = new Map<string, CacheEntry<unknown>>()

export async function withCache<T>(
  key: string,
  fetchFn: () => Promise<T>,
  ttl: number = 10 * 60 * 1000
): Promise<T> {
  const entry = cache.get(key)
  const now = Date.now()

  if (entry?.value && entry.timestamp && (now - entry.timestamp < ttl)) {
    return entry.value as T
  }

  if (entry?.promise) {
    return entry.promise as Promise<T>
  }

  const promise = fetchFn()
    .then(value => {
      cache.set(key, { promise: null, value, timestamp: Date.now() })
      return value
    })
    .catch(err => {
      cache.delete(key)
      throw err
    })

  cache.set(key, { promise, value: null, timestamp: 0 })
  return promise
}

export function clearCache(key?: string) {
  if (key) cache.delete(key)
  else cache.clear()
}
